import React from 'react';
import { IIconProps } from './IIconProps';

export const AvatarPlaceholder = ({
	iconClass = '',
	title = '',
}: IIconProps) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			version="1.1"
			viewBox="0 0 36 36"
			className={`icon ${iconClass}`}
		>
			{title && <title>{title}</title>}
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M18 0C8.064 0 0 8.064 0 18C0 27.936 8.064 36 18 36C27.936 36 36 27.936 36 18C36 8.064 27.936 0 18 0ZM18.0002 5.40005C20.9882 5.40005 23.4002 7.81206 23.4002 10.8001C23.4002 13.7881 20.9882 16.2001 18.0002 16.2001C15.0122 16.2001 12.6002 13.7881 12.6002 10.8001C12.6002 7.81206 15.0122 5.40005 18.0002 5.40005ZM7.20044 25.1639C9.52244 28.6559 13.5004 30.9599 18.0004 30.9599C22.5004 30.9599 26.4784 28.6559 28.8004 25.1639C28.7464 21.5819 21.5824 19.6199 18.0004 19.6199C14.4004 19.6199 7.25444 21.5819 7.20044 25.1639Z"
				fill="#000733"
				fillOpacity="0.16"
			/>
		</svg>
	);
};
